import moment from 'moment';

export default (() => {

    function decorateDateTime(obj) {

        if (obj.start_date && obj.end_date) {
            const startDate = moment(obj.start_date);
            const endDate   = moment(obj.end_date);

            return {
                ...obj,
                start_date: startDate.format('YYYY-MM-DD'),
                start_time: startDate.format('HH:mm'),
                end_date:   endDate.format('YYYY-MM-DD'),
                end_time:   endDate.format('HH:mm')
            };
        } else {
            return obj;
        }
    }

    function decorateStartEndDateTime(obj) {

        if (obj.multiple_days) {

            const event_days = obj.multiple_days_events;
            let new_event_days = [];
            event_days.map((value, index) => {

                new_event_days[index] = decorateDateTime(value);
            })

            obj.multiple_days_events = new_event_days;
        }

        return decorateDateTime(obj)


    }

    function formatStartEndDates(obj) {

        var params = { ...obj };


        if (params.start_date && params.start_time) {

            params.start_date += ' ' + params.start_time;
        }

        if (params.end_date && params.end_time) {

            params.end_date += ' ' + params.end_time;
        }

        if (params.multiple_days_events) {

            const event_days = params.multiple_days_events;
            let new_event_days = [];
            event_days.map((value, index) => {

                new_event_days[index] = formatStartEndDates(value);
            })

            params.multiple_days_events = new_event_days;
        }

        if (params.multiple_days && params.start_date === null) {
            delete params.start_date;
        }

        if (params.multiple_days && params.end_date === null) {
            delete params.end_date;
        }

        if (params.multiple_days) {
            delete params.timetable_id;
        }

        delete params.start_time;
        delete params.end_time;

        return params;
    }

    return {
        decorateStartEndDateTime,
        formatStartEndDates
    };

})();


// WEBPACK FOOTER //
// ./services/dateTimeDecorator.js